export default __webpack_public_path__ + "static/media/category-3.c04302e5.svg";